export const config = {
  title: 'Move to Onboarding',
  bodyText: 'Are you sure you want to move this candidate to onboarding?',
  okText: 'Yes',
  cancelText: 'No',
  width: 420,
  successMessage: 'Moved to onboarding successfully',
  // On success, land on the Onboarding screen (instead of returning to the
  // background list). DynamicPopupRoute honours this and still stamps a
  // refreshTimestamp so the destination reloads fresh.
  successNavigate: '/onboarding',
  fields: [
    {
      name: 'sendOnboardingEmail',
      type: 'priority-checkbox',
      checkboxLabel: 'Send Onboarding Email',
    },
  ],
};
